/* ============================================================
   QI PREMIUM GIFT CARD OPTIONS
   ============================================================ */
(function () {
  'use strict';
  if (window.__qiGiftOptionsLoaded) return;
  window.__qiGiftOptionsLoaded = true;
  /* ==========================================================
     INITIALISATION
     ========================================================== */
  function initAll(scope) {
    const context =
      scope || document;
    context
      .querySelectorAll(
        '[data-qi-gift-options]'
      )
      .forEach(
        initQiGiftOptions
      );
  }
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }
  /*
   * Reinitialise if Shopify Theme Editor reloads section.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('[data-qi-gift-options]')) initQiGiftOptions(node);
        initAll(node);
      }
      for (const node of record.removedNodes) {
        if (node.nodeType !== 1) continue;
        const roots = node.matches('[data-qi-gift-options]') ? [node] : node.querySelectorAll('[data-qi-gift-options]');
        roots.forEach((root) => {
          if (!root.isConnected) {
            root.qiUnsubscribe?.();
            document.getElementById(`qi-gift-preview-${root.dataset.sectionId}`)?.remove();
          }
        });
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  /* ==========================================================
     MAIN COMPONENT
     ========================================================== */
  function initQiGiftOptions(root) {
    /*
     * Prevent duplicate event listeners.
     */
    if (
      root.dataset.qiInitialised === 'true'
    ) {
      return;
    }
    root.dataset.qiInitialised =
      'true';
    const sectionId =
      root.dataset.sectionId;
    /*
     * Locate surrounding Shopify section.
     */
    const section =
      root.closest('.shopify-section') ||
      root.closest('section') ||
      document;
    /*
     * Locate Dawn / Dawn-style product form.
     */
    const productFormElement =
      root.closest('product-form') ||
      section.querySelector(
        `product-form[data-section-id="${sectionId}"]`
      ) ||
      section.querySelector(
        'product-form'
      );
    const productForm =
      root.closest('form') || (productFormElement
        ? productFormElement.querySelector(
            'form[action*="/cart/add"]'
          )
        : section.querySelector(
            'form[action*="/cart/add"]'
          ));
    if (!productForm) {
      console.warn(
        'Qi Gift Options: product form could not be found.'
      );
      return;
    }
    const addonVariantId =
      Number(
        root.dataset.addonVariantId
      );
    /* ========================================================
       ELEMENTS
       ======================================================== */
    const formatInputs =
      root.querySelectorAll(
        '[data-qi-format]'
      );
    const physicalFields =
      root.querySelector(
        '[data-physical-fields]'
      );
    const openToggle =
      root.querySelector(
        '[data-open-date-toggle]'
      );
    const openWrapper =
      root.querySelector(
        '[data-open-date-wrapper]'
      );
    const openDateInput =
      root.querySelector(
        '[data-qi-open-date]'
      );
    const giftPreviewOpen =
      root.querySelector(
        '[data-gift-preview-open]'
      );
    const giftPreviewModal =
      root.querySelector(
        '[data-gift-preview-modal]'
      );
    const giftPreviewCloseButtons =
      root.querySelectorAll(
        '[data-gift-preview-close]'
      );
    const giftPreviewImage =
      root.querySelector(
        '[data-gift-preview-image]'
      );
    const messageInput =
      root.querySelector(
        '[data-qi-property="Gift message"]'
      );
    const messageCount =
      root.querySelector(
        '[data-message-count]'
      );
    const submitButton =
      productForm.querySelector(
        '[name="add"]'
      ) ||
      productForm.querySelector(
        '[type="submit"]'
      );
    const physicalSubmitButton =
      root.querySelector(
        '[data-qi-physical-submit]'
      );
    const physicalSubmitButtonText =
      root.querySelector(
        '[data-qi-physical-submit-text]'
      );
    const dynamicCheckout =
      productForm.querySelector(
        '.shopify-payment-button'
      );
    const submitButtonText =
      submitButton
        ? (
            submitButton.querySelector('span') ||
            submitButton
          )
        : null;
    /*
     * Shopify native gift recipient form.
     */
    const recipientForm =
      productForm.querySelector(
        'recipient-form.recipient-form'
      ) ||
      productForm.querySelector(
        '.recipient-form'
      );
    /* ========================================================
       RELABEL SHOPIFY EGIFT CHECKBOX
       ======================================================== */
    const giftingInputs = root.querySelectorAll('[data-qi-gift-for]');
    const emailInputs = root.querySelectorAll('[data-qi-email-to]');
    const choices = root.querySelector('[data-qi-gift-choices]');
    const emailOptions = root.querySelector('[data-qi-email-options]');
    const recipientPanel = root.querySelector('[data-qi-recipient-panel]');
    const emailHelp = root.querySelector('[data-qi-email-help]');
    const deliveryProperty = root.querySelector('[data-qi-delivery-property]');
    const legacyRecipient = root.querySelector('[data-qi-legacy-recipient]');
    const nativeCheckbox = recipientForm?.querySelector('input[type="checkbox"]');
    const legacyDate = root.querySelector('[data-qi-legacy-date]');
    const legacyDateProperty = root.querySelector('[data-qi-legacy-date-property]');
    let physicalBusy = false;
    productForm.setAttribute('data-qi-voucher-form', '');

    function selectedFormat() {
      if (root.querySelector('[data-qi-gift-for]:checked')?.value !== 'someone') return 'egift';
      return root.querySelector('[data-qi-format]:checked')?.value || 'egift';
    }

    function isDirectEmail() {
      return root.querySelector('[data-qi-gift-for]:checked')?.value === 'someone' &&
        selectedFormat() === 'egift' && root.querySelector('[data-qi-email-to]:checked')?.value === 'recipient';
    }

    function purchaseBlocked() {
      const info = root.closest('[id^="ProductInfo-"]');
      return info?.dataset.qiEnded === 'true' || info?.dataset.qiChristmasEnded === 'true' ||
        submitButton?.disabled || submitButton?.getAttribute('aria-disabled') === 'true';
    }

    function updateFormatUI() {
      const gifting = root.querySelector('[data-qi-gift-for]:checked')?.value === 'someone';
      const isPhysical = selectedFormat() === 'physical';
      const direct = isDirectEmail();
      choices.hidden = !gifting;
      emailOptions.hidden = !gifting || isPhysical;
      recipientPanel.hidden = !direct;
      emailHelp.hidden = direct;
      if (physicalFields) physicalFields.hidden = !isPhysical;
      if (deliveryProperty) deliveryProperty.disabled = isPhysical;
      root.querySelectorAll('.qi-gift-format-card').forEach((card) => {
        card.classList.toggle('is-selected', Boolean(card.querySelector('[data-qi-format]:checked')));
      });
      if (nativeCheckbox) {
        if (nativeCheckbox.checked !== direct) {
          nativeCheckbox.checked = direct;
          nativeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const control = recipientForm.querySelector('[id^="Recipient-control-"]');
        if (control) control.disabled = true;
        recipientForm.querySelectorAll('.recipient-fields input, .recipient-fields textarea, [id^="Recipient-timezone-offset-"]').forEach((field) => {
          field.disabled = !direct;
        });
        const email = recipientForm.querySelector('input[type="email"]');
        if (email) email.required = direct;
      }
      if (legacyRecipient) {
        legacyRecipient.querySelectorAll('input, textarea').forEach((field) => {
          field.disabled = !direct;
          if (field.type === 'email') field.required = direct;
          if (!direct) field.setCustomValidity('');
        });
      }
      if (submitButton) submitButton.hidden = isPhysical;
      if (physicalSubmitButton) {
        physicalSubmitButton.hidden = !isPhysical;
        physicalSubmitButton.disabled = physicalBusy || !addonVariantId || purchaseBlocked();
      }
      if (dynamicCheckout) dynamicCheckout.hidden = isPhysical || direct;
      productFormElement?.classList.toggle('qi-physical-selected', isPhysical);
    }

    [...formatInputs, ...giftingInputs, ...emailInputs].forEach((input) => {
      input.addEventListener('change', updateFormatUI);
    });

    if (legacyDate) {
      legacyDate.min = localISODate(new Date());
      legacyDate.addEventListener('change', () => {
        legacyDate.setCustomValidity('');
        const parts = legacyDate.value.split('-');
        legacyDateProperty.value = parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : '';
      });
    }
    if (submitButton) new MutationObserver(updateFormatUI).observe(submitButton, {
      attributes: true, attributeFilter: ['disabled', 'aria-disabled']
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      root.qiUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form' || String(event.productVariantId) !== String(productForm.elements.namedItem('id')?.value)) return;
        queueMicrotask(() => {
          if (!root.isConnected) return;
          root.querySelector('[data-qi-gift-for][value="myself"]').checked = true;
          root.querySelector('[data-qi-format][value="egift"]').checked = true;
          root.querySelector('[data-qi-email-to][value="me"]').checked = true;
          legacyRecipient?.querySelectorAll('input:not([type="hidden"]), textarea').forEach((field) => { field.value = ''; });
          if (legacyDateProperty) legacyDateProperty.value = '';
          updateFormatUI();
        });
      });
    }

    /* ========================================================
       GIFT PRESENTATION PREVIEW
       ======================================================== */
    if (
      giftPreviewOpen &&
      giftPreviewModal
    ) {
      let lastFocusedElement =
        null;
      let previewPreloadStarted =
        false;
      /*
       * Move the modal to <body>.
       * This prevents sticky headers/navs with their own stacking
       * contexts from ever appearing above the lightbox.
       */
      if (
        giftPreviewModal.parentNode !==
        document.body
      ) {
        document.body.appendChild(
          giftPreviewModal
        );
      }
      function preloadGiftPreview() {
        if (
          previewPreloadStarted ||
          !giftPreviewImage
        ) {
          return;
        }
        const previewSrc =
          giftPreviewImage.dataset.giftPreviewSrc;
        if (!previewSrc) {
          return;
        }
        previewPreloadStarted =
          true;
        const preloader =
          new Image();
        preloader.decoding =
          'async';
        preloader.src =
          previewSrc;
        /*
         * decode() warms the decoded image where supported,
         * so opening the modal doesn't wait on decoding.
         */
        if (
          typeof preloader.decode ===
          'function'
        ) {
          preloader
            .decode()
            .catch(
              function () {}
            );
        }
        preloader.addEventListener(
          'load',
          function () {
            giftPreviewImage.src =
              previewSrc;
            giftPreviewImage.hidden =
              false;
            giftPreviewImage.dataset.qiLoaded =
              'true';
          },
          {
            once: true
          }
        );
      }
      /*
       * Start preloading only after the main page has finished loading,
       * so the preview does not compete with critical product assets.
       * requestIdleCallback is used when available.
       */
      function scheduleGiftPreviewPreload() {
        if (
          'requestIdleCallback' in window
        ) {
          window.requestIdleCallback(
            preloadGiftPreview,
            {
              timeout: 1200
            }
          );
        } else {
          window.setTimeout(
            preloadGiftPreview,
            350
          );
        }
      }
      if (
        document.readyState ===
        'complete'
      ) {
        scheduleGiftPreviewPreload();
      } else {
        window.addEventListener(
          'load',
          scheduleGiftPreviewPreload,
          {
            once: true
          }
        );
      }
      function openGiftPreview(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        lastFocusedElement =
          document.activeElement;
        /*
         * Open the modal immediately.
         * The preview image itself is deliberately NOT loaded
         * until after the modal has painted.
         */
        giftPreviewModal.hidden =
          false;
        document.body.classList.add(
          'qi-gift-preview-open'
        );
        const closeButton =
          giftPreviewModal.querySelector(
            '.qi-gift-preview-modal__close'
          );
        if (closeButton) {
          closeButton.focus();
        }
        /*
         * In the normal case the image is already cached and decoded
         * by the background preload above. If the customer clicks
         * extremely quickly, start the same preload immediately.
         */
        if (
          giftPreviewImage &&
          !giftPreviewImage.dataset.qiLoaded
        ) {
          preloadGiftPreview();
        }
      }
      function closeGiftPreview(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (giftPreviewModal.hidden) {
          return;
        }
        giftPreviewModal.hidden =
          true;
        document.body.classList.remove(
          'qi-gift-preview-open'
        );
        if (
          lastFocusedElement &&
          typeof lastFocusedElement.focus ===
            'function'
        ) {
          lastFocusedElement.focus();
        }
      }
      giftPreviewOpen.addEventListener(
        'click',
        openGiftPreview
      );
      giftPreviewCloseButtons.forEach(
        function (button) {
          button.addEventListener(
            'click',
            closeGiftPreview
          );
        }
      );
      document.addEventListener(
        'keydown',
        function (event) {
          if (
            event.key === 'Escape' &&
            !giftPreviewModal.hidden
          ) {
            closeGiftPreview(event);
          }
        }
      );
    }
    /* ========================================================
       MESSAGE CHARACTER COUNTER
       ======================================================== */
    if (
      messageInput &&
      messageCount
    ) {
      function updateMessageCounter() {
        messageCount.textContent =
          String(
            messageInput.value.length
          );
      }
      messageInput.addEventListener(
        'input',
        updateMessageCounter
      );
      updateMessageCounter();
    }
    /* ========================================================
       OPEN DATE MINIMUM
       ======================================================== */
    const today =
      localISODate(
        new Date()
      );
    if (openDateInput) {
      openDateInput.min =
        today;
    }
    /* ========================================================
       OPEN ON DATE TOGGLE
       ======================================================== */
    if (
      openToggle &&
      openWrapper
    ) {
      openToggle.addEventListener(
        'change',
        function () {
          const enabled =
            openToggle.checked;
          openWrapper.hidden =
            !enabled;
          if (
            !enabled &&
            openDateInput
          ) {
            openDateInput.value =
              '';
            openDateInput.setCustomValidity(
              ''
            );
          }
        }
      );
    }
    /* ========================================================
       CLEAR REQUIRED FIELD ERRORS
       ======================================================== */
    root
      .querySelectorAll(
        '[data-physical-required]'
      )
      .forEach(
        function (field) {
          field.addEventListener(
            'input',
            function () {
              field.setCustomValidity(
                ''
              );
            }
          );
        }
      );
    /* ========================================================
       CLEAR DATE ERROR
       ======================================================== */
    if (openDateInput) {
      openDateInput.addEventListener(
        'change',
        function () {
          openDateInput.setCustomValidity(
            ''
          );
        }
      );
    }
    /* ========================================================
       INTERCEPT PHYSICAL ADD-TO-CART ONLY
       ======================================================== */
    /*
     * eGift:
     *
     * Shopify's normal product form handles everything.
     *
     * Physical:
     *
     * We intercept and add:
     *
     * 1. Voucher
     * 2. £4.99 physical presentation product
     */
    async function submitPhysicalGift(loadingButton) {
      if (physicalBusy || purchaseBlocked() || !addonVariantId) return;
      if (!validatePhysicalGift(root, openToggle, openDateInput)) return;
      const button = loadingButton || submitButton;
      physicalBusy = true;
      root.querySelectorAll('[data-qi-gift-for], [data-qi-format], [data-qi-email-to]').forEach((input) => {
        input.dataset.qiWasDisabled = String(input.disabled);
        input.disabled = true;
      });
      setLoadingState(button, true);
      if (button) button.disabled = true;
      let added = false;
      try {
        await addPhysicalGiftToCart(root, productForm, addonVariantId);
        added = true;
        await openCartDrawer();
        if (productFormElement) productFormElement.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      } catch (error) {
        if (added || error.qiCartUncertain) {
          showError(productForm, root.dataset.refreshMessage);
          window.location.assign(window.routes?.cart_url || ((window.Shopify?.routes?.root || '/') + 'cart'));
        } else {
          showError(productForm, error.message || root.dataset.refreshMessage);
        }
      } finally {
        physicalBusy = false;
        setLoadingState(button, false);
        root.querySelectorAll('[data-qi-was-disabled]').forEach((input) => {
          input.disabled = input.dataset.qiWasDisabled === 'true';
          delete input.dataset.qiWasDisabled;
        });
        updateFormatUI();
      }
    }
    if (physicalSubmitButton) {
      physicalSubmitButton.addEventListener(
        'click',
        async function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (
            selectedFormat() !==
            'physical'
          ) {
            return;
          }
          await submitPhysicalGift(
            physicalSubmitButton
          );
        }
      );
    }
    productForm.addEventListener(
      'submit',
      async function (event) {
        if (
          selectedFormat() !==
          'physical'
        ) {
          /*
           * EGIFT:
           *
           * Leave Shopify's normal
           * gift voucher process alone.
           */
          if (purchaseBlocked()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          if (isDirectEmail()) {
            const fields = recipientPanel.querySelectorAll('input:not([type="hidden"]), textarea');
            for (const field of fields) {
              if (!field.disabled && !field.checkValidity()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                field.reportValidity();
                return;
              }
            }
          }
          if (productFormElement) productFormElement.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          return;
        }
        /*
         * PHYSICAL:
         *
         * The original Shopify CTA is hidden for this mode.
         * Block any accidental native submit and let the dedicated
         * physical gift button handle the two-line-item add.
         */
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      },
      /*
       * Capture phase is intentional.
       * Dawn also listens for product form submit events.
       */
      true
    );
    /* ========================================================
       INITIAL STATE
       ======================================================== */
    updateFormatUI();
    root.hidden = false;
  }
  /* ==========================================================
     SHOPIFY EGIFT RECIPIENT FORM
     ========================================================== */
  function customiseRecipientForm(
    recipientForm
  ) {
    if (!recipientForm) {
      return;
    }
    /*
     * Change Shopify's native checkbox wording.
     */
    const checkboxLabelText =
      recipientForm.querySelector(
        'label.recipient-checkbox > span:last-child'
      );
    if (checkboxLabelText) {
      checkboxLabelText.textContent =
        'Send this eGift directly to the recipient';
    }
  }
  /* ==========================================================
     PHYSICAL VALIDATION
     ========================================================== */
  function validatePhysicalGift(root, openToggle, openDateInput) {
    for (const field of root.querySelectorAll('[data-physical-required]')) {
      field.setCustomValidity(field.value.trim() ? '' : root.dataset.requiredMessage);
      if (!field.reportValidity()) { field.focus(); return false; }
    }
    if (openDateInput) {
      openDateInput.setCustomValidity('');
      if (openToggle?.checked) {
        if (!openDateInput.value || openDateInput.value < localISODate(new Date())) {
          openDateInput.setCustomValidity(root.dataset.dateMessage);
        }
        if (!openDateInput.reportValidity()) { openDateInput.focus(); return false; }
      }
    }
    return true;
  }
  /* ==========================================================
     ADD PHYSICAL GIFT
     ========================================================== */
  async function addPhysicalGiftToCart(
    root,
    productForm,
    addonVariantId
  ) {
    const voucherVariantInput =
      productForm.querySelector(
        '[name="id"]'
      );
    if (!voucherVariantInput) {
      throw new Error(
        'Voucher variant could not be found.'
      );
    }
    const voucherVariantId =
      Number(
        voucherVariantInput.value
      );
    if (!voucherVariantId) {
      throw new Error(
        'Please select a valid voucher option.'
      );
    }
    /*
     * Quantity
     */
    const formData = new FormData(productForm);
    const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
    /*
     * Unique reference linking voucher
     * and physical presentation line.
     */
    const giftUid =
      generateGiftUid();
    /* ========================================================
       VOUCHER PROPERTIES
       ======================================================== */
    const voucherProperties = {};
    for (const [name, value] of formData.entries()) {
      const property = /^properties\[(.+)\]$/.exec(name);
      if (property && typeof value === 'string') voucherProperties[property[1]] = value;
    }
    Object.assign(voucherProperties, {
      'Delivery format': 'Premium Physical Gift Card',
      'To': getPropertyValue(root, 'To'),
      'From': getPropertyValue(root, 'From'),
      '_Qi Gift UID': giftUid
    });
    const messageInput =
      root.querySelector(
        '[data-qi-property="Gift message"]'
      );
    const message =
      messageInput
        ? String(
            messageInput.value || ''
          ).trim()
        : '';
    const openDate =
      getPropertyValue(
        root,
        'Open on date'
      );
    /*
     * Only include optional properties
     * when populated.
     */
    if (message) {
      voucherProperties[
        'Gift message'
      ] = message;
    }
    if (openDate) {
      voucherProperties[
        'Open on date'
      ] = openDate;
    }
    /* ========================================================
       ADD-ON PROPERTIES
       ======================================================== */
    const addonProperties = {
      '_Qi Gift UID':
        giftUid,
      '_Linked voucher':
        root.dataset.productTitle || '',
      '_Voucher variant ID':
        String(
          voucherVariantId
        )
    };
    /* ========================================================
       AJAX CART PAYLOAD
       ======================================================== */
    const payload = {
      items: [
        /*
         * Original voucher
         */
        {
          id:
            voucherVariantId,
          quantity:
            quantity,
          properties:
            voucherProperties,
          ...(formData.get('selling_plan') ? { selling_plan: formData.get('selling_plan') } : {})
        },
        /*
         * £4.99 physical presentation
         */
        {
          id:
            addonVariantId,
          quantity:
            quantity,
          properties:
            addonProperties
        }
      ]
    };
    /* ========================================================
       SHOPIFY AJAX CART
       ======================================================== */
    const rootUrl =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    let response;
    try {
      response = await fetch(
        rootUrl + 'cart/add.js',
        {
          method:
            'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json',
            'X-Requested-With':
              'XMLHttpRequest'
          },
          body:
            JSON.stringify(
              payload
            )
        }
      );
    } catch (error) {
      error.qiCartUncertain = true;
      throw error;
    }
    let responseBody =
      null;
    try {
      responseBody =
        await response.json();
    } catch (error) {
      responseBody =
        null;
    }
    if (!response.ok) {
      throw new Error(
        (
          responseBody &&
          (
            responseBody.description ||
            responseBody.message
          )
        ) ||
        'Unable to add the gift card to your basket.'
      );
    }
    return responseBody;
  }
  /* ==========================================================
     CART DRAWER
     ========================================================== */
  async function openCartDrawer() {
    const rootUrl =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    /*
     * Fetch completely fresh Shopify-rendered cart sections.
     *
     * A timestamp prevents theme/CDN/browser caching from returning
     * the pre-add empty drawer.
     */
    const cacheBuster =
      Date.now();
    const sectionUrl =
      rootUrl +
      '?sections=cart-drawer,cart-icon-bubble' +
      '&_qi=' +
      cacheBuster;
    const response =
      await fetch(
        sectionUrl,
        {
          method:
            'GET',
          headers: {
            'Accept':
              'application/json',
            'X-Requested-With':
              'XMLHttpRequest'
          },
          cache:
            'no-store'
        }
      );
    if (!response.ok) {
      throw new Error(
        'The basket was updated, but the basket drawer could not be refreshed.'
      );
    }
    const sectionsResponse =
      await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      const html = sectionsResponse?.['cart-drawer'];
      if (!html || !sectionsResponse?.['cart-icon-bubble']) throw new Error('Basket sections are unavailable.');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newDrawer = parsed.querySelector('cart-drawer');
      if (!newDrawer || !parsed.querySelector('#CartDrawer')) throw new Error('Basket markup is unavailable.');
      drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      drawer.renderContents({ sections: sectionsResponse });
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return;
    }
    window.location.assign(window.routes?.cart_url || (rootUrl + 'cart'));
  }
  /* ==========================================================
     PROPERTY VALUE
     ========================================================== */
  function getPropertyValue(
    root,
    propertyName
  ) {
    const element =
      root.querySelector(
        `[data-qi-property="${propertyName}"]`
      );
    if (!element) {
      return '';
    }
    return String(
      element.value || ''
    ).trim();
  }
  /* ==========================================================
     UNIQUE GIFT ID
     ========================================================== */
  function generateGiftUid() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID ===
      'function'
    ) {
      return (
        window.crypto.randomUUID()
      );
    }
    return (
      'qi-' +
      Date.now() +
      '-' +
      Math.random()
        .toString(36)
        .slice(2, 10)
    );
  }
  /* ==========================================================
     LOCAL DATE YYYY-MM-DD
     ========================================================== */
  function localISODate(date) {
    const year =
      date.getFullYear();
    const month =
      String(
        date.getMonth() + 1
      ).padStart(
        2,
        '0'
      );
    const day =
      String(
        date.getDate()
      ).padStart(
        2,
        '0'
      );
    return (
      year +
      '-' +
      month +
      '-' +
      day
    );
  }
  /* ==========================================================
     LOADING STATE
     ========================================================== */
  function setLoadingState(
    button,
    loading
  ) {
    if (!button) {
      return;
    }
    if (loading) {
      button.setAttribute(
        'aria-disabled',
        'true'
      );
      button.classList.add(
        'loading'
      );
    } else {
      button.removeAttribute(
        'aria-disabled'
      );
      button.classList.remove(
        'loading'
      );
    }
  }
  /* ==========================================================
     ERROR DISPLAY
     ========================================================== */
  function showError(
    productForm,
    message
  ) {
    const wrapper =
      (productForm.closest('product-form') || productForm).querySelector(
        '.product-form__error-message-wrapper'
      );
    const text =
      wrapper
        ? wrapper.querySelector(
            '.product-form__error-message'
          )
        : null;
    if (
      wrapper &&
      text
    ) {
      text.textContent =
        message;
      wrapper.hidden =
        false;
      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      alert(
        message
      );
    }
  }
})();
